import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useApp } from "@/context/AppContext";
import { api } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { Button } from "@/components/ui/button";
import { Heart } from "lucide-react";

export default function Wishlist() {
  const { wishlist, t } = useApp();
  const [products, setProducts] = useState([]);

  useEffect(() => {
    if (wishlist.length === 0) { setProducts([]); return; }
    api.get("/products", { params: { limit: 200 } }).then((r) => {
      setProducts(r.data.filter((p) => wishlist.includes(p.id)));
    });
  }, [wishlist]);

  return (
    <div className="mx-auto max-w-7xl px-4 py-12">
      <div className="mb-8 flex items-center gap-3">
        <Heart className="w-7 h-7 text-pink-500 fill-pink-500" />
        <h1 className="text-4xl font-display font-bold">{t("wishlist.title")}</h1>
      </div>

      {products.length === 0 ? (
        <div className="text-center py-20">
          <p className="text-muted-foreground mb-6">{t("wishlist.empty")}</p>
          <Button asChild size="lg" className="rounded-full btn-primary" data-testid="wishlist-explore-btn">
            <Link to="/produtos">{t("cta.viewProducts")}</Link>
          </Button>
        </div>
      ) : (
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {products.map((p) => <ProductCard key={p.id} product={p} />)}
        </div>
      )}
    </div>
  );
}
